import { useEffect, useState } from "react"
import cx from 'classnames'
import { capitalize, xor } from "libraries/lodash"
import { catchError, NEVER } from "rxjs"
import debug from 'front-end-core/core/debug'
import { toast } from 'react-toastify'
import ClockIcon from '@material-ui/icons/AccessTime'
import ErrorIcon from '@material-ui/icons/Error'
import CheckIcon from '@material-ui/icons/CheckCircle'
import notificationToast from 'helpers/notificationToast'
import { CaEmailDays, EmailPreferences } from "types/User"
import SelectEmailOptIn from "./SelectEmailOptIn"
import SelectEmailDays from "./SelectEmailDays"
import ControlButtons from "./ControlButtons"
import { updateEmailPreferences } from "services/SessionService"

type AolPreferenceProps = {
  aolPreference: EmailPreferences[keyof EmailPreferences]
}

export default function AolPreference ({ aolPreference }: AolPreferenceProps) {
  const [workingPreferences, setWorkingPreferences] = useState(aolPreference)
  const [changed, setChanged] = useState(false)
  const [submitted, setSubmitted] = useState(false)

  useEffect(() => {
    setChanged(false)
    setSubmitted(false)
  }, [submitted])

  const handleToggleEmails = (value: boolean) => {
    setWorkingPreferences({
      ...workingPreferences,
      'caEmails': value
    })
    setChanged(true)
  }

  const handleChangeDays = (value: number) => {
    setWorkingPreferences({
      ...workingPreferences,
      caEmailDays:  xor(workingPreferences['caEmailDays'], [value]) as CaEmailDays
    })
    setChanged(true)
  }

  const handleSave = () => {
    const notificationId = notificationToast(<ClockIcon />, toast.TYPE.INFO, 'Saving', '')

    setSubmitted(true)

    updateEmailPreferences(workingPreferences)
      .pipe(
        catchError(e => {
          debug.warn(e)
          toast.dismiss(notificationId)
          notificationToast(<ErrorIcon />, toast.TYPE.ERROR, 'Please try again.', 'bg-indian-red white')
          return NEVER
        })
      )
      .subscribe(() => {
        toast.dismiss(notificationId)
        notificationToast(<CheckIcon />, toast.TYPE.SUCCESS, 'Preferences saved', 'bg-dark-sea-green white')
      })
  }

  const handleCancel = () => {
    setWorkingPreferences({ ...aolPreference })
    setChanged(false)
    setSubmitted(false)
  }

  const { caEmailDays = [], caEmails, areaOfLaw } = workingPreferences

  return (
    <form className={cx('flex flex-column f5 lighter', {'mb10 pb4': !changed})}>
      <h3 className="">{capitalize(areaOfLaw as string)}</h3>
      <div className='account-item-rows'>
        <SelectEmailOptIn {...{ caEmails, handleChange: handleToggleEmails }} />
        <SelectEmailDays {...{ areaOfLaw, caEmailDays, caEmails, handleChange: handleChangeDays }} />
      </div>
      <ControlButtons {...{ changed, handleSave, handleCancel }} />
    </form>
  )
}